import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from 'redux';
import reducers from '../reducers';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas/index';
import { AUTH_TOKEN, IS_2FA_ENABLED } from '../constants/Auth';

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

// Load persisted state from localStorage
function loadState() {
  try {
    const token = localStorage.getItem(AUTH_TOKEN);
    const is2FAEnabled = localStorage.getItem(IS_2FA_ENABLED);

    if (token) {
      return {
        auth: {
          loading: false,
          message: '',
          showMessage: false,
          redirect: '/dashboard',
          token: token,
          loginData: {
            UserId: '',
            Email: '',
            AccessToken: '',
            Is2FAEnabled: is2FAEnabled,
          },
          qr: '',
          isVerified: false,
          Is2FAEnabled: is2FAEnabled === 'true',
          profile: {
            FullName: '',
            Email: '',
            Privileges: [],
          },
        },
      };
    }
    return undefined;
  } catch (err) {
    return undefined;
  }
}

function configureStore() {
  const persistedState = loadState();
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    reducers,
    persistedState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('../reducers/index', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

const store = configureStore();

export default store;
